/**
 * Generates styled HTML from a tournament document JSON object.
 * The JSON data is stored in S3 with no styling — this function
 * applies presentation at render time so styles stay in the UI layer.
 *
 * @param {{ type: string, tournamentName: string, createdAt: string, sections: {title: string, content: string}[] }} data
 * @returns {string} Full HTML document string suitable for use in an iframe srcDoc
 */
export function generateDocumentHtml(data) {
  const title = data.type === 'terms' ? 'Terms & Conditions' : 'Liability Waiver';
  const date = data.createdAt
    ? new Date(data.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    : new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  const sectionsHtml = (data.sections || []).map((s, i) =>
    `<div class="section"><h2>${i + 1}. ${s.title}</h2><p>${s.content}</p></div>`
  ).join('');

  return `<!DOCTYPE html><html><head><meta charset="UTF-8">
<style>
body{font-family:Arial,sans-serif;max-width:760px;margin:0 auto;padding:32px 20px;color:#1f2937;line-height:1.6;background-color:#ffffff}
h1{color:#1e3a8a;border-bottom:2px solid #1e3a8a;padding-bottom:10px;margin-bottom:6px}
.meta{color:#6b7280;font-size:.9em;margin-bottom:28px}
h2{color:#374151;font-size:1.05em;margin-bottom:4px}
p{color:#4b5563;margin:0 0 4px}
.section{margin-bottom:22px}
.footer{margin-top:40px;padding-top:14px;border-top:1px solid #e5e7eb;color:#9ca3af;font-size:.82em}
</style></head><body>
<h1>${title}</h1>
<div class="meta"><strong>${data.ownerLabel || 'Tournament'}:</strong> ${data.tournamentName || data.programName || 'Tournament'}<br><strong>Effective Date:</strong> ${date}</div>
${sectionsHtml}
<div class="footer"><p>By registering for this ${(data.ownerLabel || 'tournament').toLowerCase()}, you acknowledge that you have read, understood, and agree to be bound by these ${title.toLowerCase()}.</p></div>
</body></html>`;
}
